<script>
    import mapboxgl from 'mapbox-gl';
    import { onMount } from 'svelte';
    import Legend from './components/Legend.svelte';
    import neLand from './data/ne_50m_land.json';
    
    let { width, manifestData, copy, params } = $props();
    
    const initLat = 22;
    const initLng = -105;
    let mapContainer = $state();
    let map = $state();
    // let lat = $derived(params.lat || initLat);
    // let lng = $derived(params.lng || initLng);
    // let zoom = $derived(params.zoom || 3.5);

    mapboxgl.accessToken = import.meta.env.VITE_MAPBOX_TOKEN || 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJja2V1M3Vyd3kwMDZrMnF0Njdhb3ZhZDk5In0.OURIYzTcS6ZzoWjXJzfANg';
    
    const desktopZoom = 3.0070987110644887;
    const desktopLat = 28.323186474406796;
    const desktopLng = -116.28080077394031;

    const mobileZoom = 2.295146720358909;
    const mobileLng = -120.31883465693548;
    const mobileLat = 28.659483105842;

    const isMobile = $derived(width < 500);
    let height = $derived(isMobile ? 450 : 500);
    let stylesLoaded = $state(false);

    $inspect(isMobile);

    onMount(() => {
        if (!mapContainer) return;

        const zoom = isMobile ? mobileZoom : desktopZoom;
        const lng = isMobile ? mobileLng : desktopLng;
        const lat = isMobile ? mobileLat : desktopLat;
        
        map = new mapboxgl.Map({
            container: mapContainer,
            style: 'mapbox://styles/cnndigital/cmo7p8vi9000h01qkdrofds74',
            zoom: zoom,
            projection: 'mercator',
            center: [lng, lat],
            minZoom: zoom,
            maxZoom: zoom,
            dragPan: false,
            scrollZoom: false,
            boxZoom: false,
            dragRotate: false,
            keyboard: false,
            doubleClickZoom: false,
            touchZoomRotate: false,
            touchPitch: false,
        });
        
        map.on('load', () => {
            stylesLoaded = true;
        });
        
        return () => {
            if (map) {
                map.remove();
            }
        };
    });

    $effect(() => {
        if (!map) return;
        const zoom = isMobile ? mobileZoom : desktopZoom;
        const lng = isMobile ? mobileLng : desktopLng;
        const lat = isMobile ? mobileLat : desktopLat;
        
        // Set in safe order to avoid minZoom > maxZoom or maxZoom < minZoom conflicts
        if (zoom > map.getMaxZoom()) {
            map.setMaxZoom(zoom);
            map.setMinZoom(zoom);
        } else {
            map.setMinZoom(zoom);
            map.setMaxZoom(zoom);
        }
        map.jumpTo({ center: [lng, lat], zoom });
    });

    $effect(() => {
        if (manifestData && stylesLoaded) {
            const files = manifestData.files;
            const latest = files[files.length - 1];
            const tilesetId = latest.tileset_id;

            // Hide the base water layer so the raster shows through cleanly
           

            // Find the first symbol (label) layer so our layers sit below all labels
            const firstLabelLayer = map.getStyle().layers.find(l => l.type === 'symbol')?.id;
            const firstLayer = map.getStyle().layers[0]?.id;

            // Remove stale layers/sources if present from a previous render


            map.addSource('sst-raster', {
                type: 'raster',
                url: `mapbox://${tilesetId}`,
                tileSize: 256,
            });

            map.addLayer({
                id: 'sst-raster',
                type: 'raster',
                source: 'sst-raster',
                paint: {
                    'raster-opacity': 0.9,
                },
            }, firstLayer);

            console.log('tilesetId', tilesetId)

            // Add Natural Earth land fill directly above the raster, still below labels
            // map.addSource('ne-land', {
            //     type: 'geojson',
            //     data: neLand,
            // });

            // map.addLayer({
            //     id: 'ne-land',
            //     type: 'fill',
            //     source: 'ne-land',
            //     paint: {
            //         'fill-color': '#f0ede8',
            //         'fill-opacity': 1,
            //     },
            // }, 'national-park');

            // map.addLayer({
            //     id: 'ne-land-border',
            //     type: 'line',
            //     source: 'ne-land',
            //     paint: {
            //         'line-color': '#aaaaaa',
            //         'line-width': 0.5,
            //     },
            // }, 'national-park');

            map.on('moveend', () => {
                // console.log('moved')
                // console.log('zoom', map.getZoom());
                // console.log('center', map.getCenter());
            })

            // console.log(map.getStyle().layers);
            // Fit map to the tileset's bounding box if available
            if (manifestData.bbox) {
                const [west, south, east, north] = manifestData.bbox;
                map.fitBounds([[west, south], [east, north]], {
                    padding: { top: 20, bottom: 20, left: 20, right: 20 },
                    duration: 0,
                });
            }
        }
    });
</script>

{#if manifestData}
    <Legend {copy} scale={manifestData.color_scale} />
{/if}
<div class="map-wrapper">
    <div bind:this={mapContainer} class="map-container" style="height: {height}px"></div>
</div>

<style lang='scss'>
    .map-wrapper {
        width: 100%;
        position: relative;
    }
    
    .map-container {
        width: 100%;
        overflow: hidden;
    }
    
    :global(.mapboxgl-ctrl-attrib) {
        font-size: 10px;
    }
    
    :global(.mapboxgl-ctrl-logo) {
        margin: 0 0 2px 2px;
    }
</style>
